import { getItem } from "./localStorageControl";

// shopDetails.rs_symbol comes from the POS shop settings currency select:
//   list pick   -> "Algeria(د.ج)"  i.e. `${country.name}(${symbol})`
//   custom pick -> "AED"           the raw symbol typed by the user
// Same parsing as the POS app so both show the exact same symbol.

const DEFAULT_SYMBOL = "₹";

// FSI / PDI unicode isolates: keep RTL symbols (د.ج, ر.س ...) from
// flipping order with the amount next to them, e.g. "د.ج100" -> "100ج.د"
const ISOLATE_START = "⁨";
const ISOLATE_END = "⁩";

export const parseCurrencySymbol = (rsSymbol) => {
  if (!rsSymbol || typeof rsSymbol !== "string") return DEFAULT_SYMBOL;
  const value = rsSymbol.trim();
  const matched = /\(([^)]+)\)\s*$/.exec(value);
  if (matched && matched[1].trim()) return matched[1].trim();
  return value || DEFAULT_SYMBOL;
};

// symbol ready to render right before an amount
export const getCurrency = () => {
  const symbol = getItem("Currency") || DEFAULT_SYMBOL;
  return `${ISOLATE_START}${symbol}${ISOLATE_END}`;
};
